import React, { useState, useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Fab from "@mui/material/Fab";
import EditIcon from "@mui/icons-material/Edit";
import ArchiveIcon from "@mui/icons-material/Archive";
import swal from 'sweetalert';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Pagination from "@mui/material/Pagination";
import AddProjectForm from "./AddProject/AddProjectForm";
import SearchProject from "./SearchProject/SearchProject";
import CheckIcon from '@mui/icons-material/Check';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import Button from '@mui/material/Button';
import Details_projects from "./Details/Details_projects";
import UpdateProject from "./UpdateProject/UpdateProject";
import Loading_animation_view from "../../loading_animation_view/loading_animation_view";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
} from "@mui/material";
import { Divider } from "@mui/material";
import {
  show_projects,
  archive_project,
} from "../../../services/project_service";
import "./list_projects.css";
import { get_directions } from "../../../services/for_allServices";


function get_direction_title(id,directions) {
  //  console.log("suppli")
  let dir_title = null;
  for (let dir of directions) {
    if (dir.id == id) { dir_title = dir.title; break; }
  }
  return dir_title;
}

function state(archived) {
  return (
    <>
      {
        archived === 1
          ? <Button variant="contained" className="status_deny">{"archivée"}</Button>
          : <Button variant="contained" className="status_success">{"non archivée"}</Button>
      }
    </>
  );
}


function List_projects() {
  const [waiting, setWaiting] = useState(false);

  const [directions, setDirections] = useState([]);
  const [projects, setProjects] = useState([]);
  const [allProjects, setAllProjects] = useState([]); // stocker tous les projets sans filtre
  const [loading, setLoading] = useState(true);
  const [openAddProject, setOpenAddProject] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedProjectForUpdate, setSelectedProjectForUpdate] = useState(null);

  const fetchProjects = async () => {
    await get_directions().then((response) => {
      setDirections(response.data);
    }).catch((error) => {
      console.log(error.response);
    });
    try {
      const response = await show_projects();
      console.log("Données récupérées :", response.data);
      if (response.data.success) {
        setProjects(response.data.data);
        setAllProjects(response.data.data); // stocke les données originales
      }
    } catch (error) {
      console.error("Erreur lors du chargement des projets :", error); // Gestion d'erreur
    } finally {
      setLoading(false); // Désactiver le chargement une fois les données récupérées
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  if (loading) {
    return <Loading_animation_view />;
  }

  const normalize = (text) => {
    return text
      .toString()
      .normalize("NFD") // décompose les lettres accentuées : ex. "é" devient "e" + "´"
      .replace(/[\u0300-\u036f]/g, "") // supprime les caractères d'accent : "e" + "´" devient juste "e"
      .toLowerCase(); // met tout en minuscules pour ignorer la casse
  };

  const handleSearch = (searchText) => {
    const keyword = normalize(searchText.trim());

    if (!keyword) {
      setProjects(allProjects); // reset si vide
    } else {
      const filtered = allProjects.filter((project) =>
        Object.values(project).some(
          (value) => value && normalize(value).includes(keyword)
        )
      );
      setProjects(filtered);
    }
  };

  const archive_project_func = async (id,projectCode, archived) => {
    swal({
      title: "Êtes-vous sûr ?",
      text: "Ce projet sera archivé.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then(async (willDelete) => {
        if (willDelete) {
          try {
            setWaiting(true);
            const response = await archive_project(projectCode,archived);
            setWaiting(false);
            if (response.data.success) {
              let tmp_project = [...projects];
              tmp_project[id].archived = archived;
              setProjects(tmp_project);
            } else {
              swal(
                "Erreur",
                "Une erreur est survenue lors de l'archivage.",
                "error"
              );
            }
          } catch (error) {
            swal(
              "Erreur",
              "Une erreur s'est produite lors de l'archivage.",
              "error"
            );
            setWaiting(false);
            console.error(error);
          }
        }
      });
  };

  const update_project_list = async (project_infos, update = null) => {
    let tmp_projects = [...projects];
    let tmp_all_projects = [...allProjects];
    console.log(update);
    if(update!=null){
      tmp_projects[update] = project_infos;
    }else{
      tmp_projects.unshift(project_infos);
      tmp_all_projects.unshift(project_infos);
    }
    setProjects(tmp_projects);
    setAllProjects(tmp_all_projects);
  }
  return (
    <div className="projects-container">
      <div className="three_forms_header_container">
        <div className="title_container" style={{ display: "flex", alignItems: "end" }}>
          <div style={{ marginRight: "5px" }}>
            <Tooltip title="Ajouter un projet" arrow>
              <Fab onClick={() => setOpenAddProject(true)}>
                <AddIcon />
              </Fab>
            </Tooltip>
          </div>
          <div>Liste des projets</div>
        </div>
        <div className="search_filter_container">
          <SearchProject onSearch={handleSearch} />
        </div>
      </div>
      <TableContainer component={Paper}>
        <Table className="projects_table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Code de projet</TableCell>
              <TableCell align="left" style={{ width: "220px" }}>
                Titre
              </TableCell>
              <TableCell align="left">Direction</TableCell>
              <TableCell align="left">Chef du projet</TableCell>
              <TableCell align="left">date de début</TableCell>
              <TableCell align="left">date de fin</TableCell>
              <TableCell align="left">Budget estimatif</TableCell>
              {/*<TableCell align="right">Budget engagé</TableCell>
              <TableCell align="right">Budget réalisé</TableCell>*/}
              <TableCell align="left" style={{ width: "30px" }}>
                Détails
              </TableCell>
              <TableCell align="left">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {projects.map((project, index) => (
              <TableRow key={index}>
                <TableCell align="left">
                  <div style={{ width: 'fit-content' }}>
                    {project.project_code}
                    <div style={{ width: '100%', display: 'flex' }}>
                      <Tooltip title="Modifier le projet">
                        <EditIcon
                          className="my_icon"
                          style={{
                            cursor: "pointer",
                            marginRight: "10px",
                            color: "#1976d2",
                          }}
                          onClick={() => {
                            setSelectedProjectForUpdate({ ...project, index: index });
                          }}
                        />
                      </Tooltip>
                    </div>
                  </div>
                </TableCell>
                <TableCell align="left">{project.title}</TableCell>
                <TableCell align="left">{get_direction_title(project.direction,directions)??"Aucune"}</TableCell>
                <TableCell align="left">{project.project_manager}</TableCell>
                <TableCell align="left">{(new Date(project.start_date)).toLocaleDateString()}</TableCell>
                <TableCell align="left">{(new Date(project.end_date)).toLocaleDateString()}</TableCell>
                <TableCell align="left">
                  {project.estimated_budget} MAD
                </TableCell>
                {/*<TableCell align="right">
                  {project.committed_budget} MAD
                </TableCell>
                <TableCell align="right">
                  {project.realized_budget} MAD
                </TableCell>*/}
                <TableCell align="left">
                  <VisibilityIcon
                    className="my_icon editIcon"
                    onClick={() => setSelectedProject(project)}
                    style={{ cursor: "pointer" }}
                  />
                </TableCell>
                <TableCell align="left">
                 <div className='documentsStatus_valide'  >
                    <div>
                      <div><CheckIcon className="checkIcon" onClick={() => archive_project_func(index, project.project_code, 0)} /></div>
                      <div><CloseSharpIcon className="closeSharpIcon" onClick={() => archive_project_func(index, project.project_code, 1)} /></div>
                    </div>
                    {state(project.archived)}
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <div
        className="pagination_container"
        style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
      >
        <Pagination />
      </div>

      {openAddProject && (
        <AddProjectForm onClose={() => setOpenAddProject(false)} update_project_list={update_project_list} directions={directions} />
      )}

      {selectedProject && (
        <Details_projects
          project={selectedProject}
          directions={directions}
          onClose={() => setSelectedProject(null)}
        />
      )}

      {selectedProjectForUpdate && (
        <UpdateProject
          project={selectedProjectForUpdate}
          onClose={() => setSelectedProjectForUpdate(null)}
          update_project_list={update_project_list}
          directions={directions}
        />
      )}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={waiting}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
export default List_projects;
